import React, { Fragment, useEffect, useState } from 'react';
import { domains } from '../configs/domains';
import * as PendingApprovalService from '../Services/PendingApprovalService';
import Chip from './Chip';
import Header from './Heading';
import StatDirection from './StatDirection';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faArrowTrendUp, faArrowTrendDown, faCopy } from '@fortawesome/free-solid-svg-icons';
import LoadingComponent from './LoadingComponent';
import ClickCopyComponent from './ClickCopyComponent';


export default function PendingApprovals({ }) {

    const [pendingApprovals, setPendingApprovals] = useState([])
    useEffect(() => {
        PendingApprovalService.getPendingApprovals().then(res => {
            setPendingApprovals(res);
        });

    }, []);

    const approve = (type, id) => {
        PendingApprovalService.approve(type, id).then(res => {
            PendingApprovalService.getPendingApprovals().then(res => {
                setPendingApprovals(res);
            });
        });
    }
    const disapprove = (type, id) => {
        PendingApprovalService.disapprove(type, id).then(res => {
            PendingApprovalService.getPendingApprovals().then(res => {
                setPendingApprovals(res);
            });
        });
    }
    return <div>
        <Header text={<span>Pending Approvals</span>} type="h3" />

        <table className="min-w-full border mt-3">
            <thead className="border-b">
                <tr>
                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Type</th>
                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Id</th>
                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>User</th>
                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Comment</th>
                    <th className='text-sm font-medium text-gray-900 px-6 py-4 text-left'>Approve/Disapprove</th>
                </tr>
            </thead>
            <tbody>
                {pendingApprovals.map((pendingApproval, index) =>
                    <tr className="border-b" key={pendingApproval.id}>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {pendingApproval.type}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {pendingApproval.id} {pendingApproval.payload.locationSlug} Rating: {pendingApproval.payload.rating}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            {pendingApproval.payload.user}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            <h3>{pendingApproval.payload.title}</h3>
                            <p>{pendingApproval.payload.body}</p>
                            {pendingApproval.payload.images.map(image => <img src={image} style={{ height: '30px' }} />)}
                        </td>
                        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                            <button onClick={() => { approve(pendingApproval.type, pendingApproval.id) }} className='bg-green-600 text-white p-4 m-5 rounded-lg'>Approve</button>
                            <button onClick={() => { disapprove(pendingApproval.type, pendingApproval.id) }} className='bg-red-600 text-white p-4 m-5 rounded-lg'>Disapprove</button>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    </div>
}